(() => {
  const name = 'indexPage';

  const indexPageModule = App[name] || {};

  App[name] = (() => {
    const init = () => {
      const { startPages } = App.indexPage;

      App.global.svgBannersScaleOnIE();

      if (startPages) {
        startPages.init();
      }
    };

    return {
      ...indexPageModule,
      init,
    };
  })();
})();
